import { Block } from '@attom';

import CS from './Breadcrumb.module.scss';

export const Breadcrumb = ({
	// box Control
	boxClass = '',
	boxSize = '',
	boxSpace = '',
	//
	paths = [], // {name: "" , onClick: fn , icon: fn }
	icon = null,
}) => {
	return (
		<Block boxClass={`${CS.container} ${boxClass}`} boxSize={boxSize} boxSpace={boxSpace}>
			{paths.map((item, i) => (
				<span
					key={i}
					className={`${CS.path} mx-2px ${item.onClick ? 'curser-pointer' : ''}`}
					onClick={item?.onClick || null}
				>
					{i === 0 && icon && typeof icon === 'function' && icon()}
					{item.icon && typeof item.icon === 'function' && item.icon()}

					<span
						className={`mx-2px ${item.onClick ? 'curser-pointer' : 'opacity-09 tc-shade-1'}`}
						style={item.textStyle ? item.textStyle : null}
						onClick={item?.onClick || null}
						value='title'
					>
						{item?.name}
					</span>
					{i + 1 < paths.length && <span className='mx-2px font-weight-900'>{'/'}</span>}
				</span>
			))}
		</Block>
	);
};
